import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { records as userRecords } from '@saucelabs/sl-module-user';
import axios from 'axios';

import * as api from './api';
import { FilterScopedPayload, SourceScopedPayload, DateFilter, SelectedFilters, FilterKey } from './types';

const ACTION_KEY = 'analytics/filterBar';
export const changeFilterSelection = createAction<SourceScopedPayload<FilterScopedPayload<string[]>>>(`${ACTION_KEY}/changeFilterSelection`);
export const changeAllFiltersSelection = createAction<SourceScopedPayload<{filters: SelectedFilters}>>(`${ACTION_KEY}/changeAllFiltersSelection`);
export const changeDateFilterSelection = createAction<DateFilter>(`${ACTION_KEY}/changeDateFilterSelection`);
export const changeOwnerFilterSelection = createAction<{keys: string[], userOrgId: string}>(`${ACTION_KEY}/changeOwnerFilterSelection`);
export const setOwnersSynchronized = createAction<void>(`${ACTION_KEY}/setOwnersSynchronized`);
export const setFiltersSynchronized = createAction<void>(`${ACTION_KEY}/setFiltersSynchronized`);
export const changeActiveFilters = createAction<FilterKey[]>(`${ACTION_KEY}/changeActiveFilters`);
export const resetFilters = createAction<SourceScopedPayload<{user: userRecords.UserRecord}>>(`${ACTION_KEY}/resetFilters`);
export const cleanup = createAction<void>(`${ACTION_KEY}/cleanup`);

export const fetchUsers = createAsyncThunk(`${ACTION_KEY}/fetchUsers`, async ({ limit = 99999, offset = 0, ...rest }: api.GetUsersParams = {}) => {
  const response = await api.getUsers({ limit, offset, ...rest });
  return response.data;
});

export const fetchTeams = createAsyncThunk(`${ACTION_KEY}/fetchTeams`, async ({ limit = 99999, offset = 0, ...rest }: api.GetTeamsParams = { }) => {
  const response = await api.getTeams({ limit, offset, ...rest });
  return response.data;
});

export const fetchFilters = createAsyncThunk(`${ACTION_KEY}/fetchFilters`, async (params: api.GetFiltersParams, { signal }) => {
  const source = axios.CancelToken.source();
  signal.addEventListener('abort', () => {
    source.cancel();
  });

  const response = await api.getFilters({
    params,
    cancelToken: source.token,
  });
  return response.data;
});
